module.exports = __webpack_public_path__ + "static/carousel2.ca98f9f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/index/carousel/carousel2.jpg
// module id = 706
// module chunks = 168707334958949